<template>
  <procedure-blocks
    :blocks="blocks"
    index="tamaro"
    v-if="blocks.length"
  />
</template>

<script setup>
import { computed, defineAsyncComponent, inject, watch } from 'vue'
import { useTamaro } from '@/vendors/integrations/tamaro'
import Blocks from '@/classes/procedures/Blocks'
import { xorBy as _xorBy, set as _set } from 'lodash'

const ProcedureBlocks = defineAsyncComponent(() => import('&/modules/procedures/layouts/ProcedureBlocks'))

const procedure = inject('procedure')
const procedure_execution = inject('procedure_execution')

const { requiredTamaroModels, requiredTamaroFields } = useTamaro()

const availableBlockModels = computed(() => procedure.value.blocks.reduce((models, block) => block.model && requiredTamaroModels.value.includes(block.model) && block.isVisible(procedure_execution.value) ? [...models, block.model] : models, []))

const blocks = computed(() => new Blocks(requiredTamaroFields.value.filter(field => !availableBlockModels.value.includes(field.model))))

watch(blocks, (to, from) => {
  if (from.length) _xorBy(to, from, 'model').forEach(block => _set(procedure_execution.value, block.model, null))
})
</script>